import DynamicChildContextMenu from "../components/dynamicChildContextMenu.vue";
import Pasteable from "./pasteable";
import {DelimiterType} from "../helpers/delimiterType";

export default {
  props: {
    isFocused: {
      type: Boolean,
      default: false
    }
  },
  mixins: [Pasteable],
  components: {DynamicChildContextMenu},
  methods: {
    deleteItem() {
      this.$emit('remove', this.model);
    },
    blur(event): void {
      this.$emit('blur', event);
    },
    enter(event): void {
      this.$emit('keydown:enter', event);
    },
    handlePaste(event): void {
      event.preventDefault();
      event.stopPropagation();
      const delimiter = /[,;]/;
      const newLineDelimiter = /\r?\n/g;
      const pastedText = (event.clipboardData || (<any>window).clipboardData).getData('text').trim();

      if (newLineDelimiter.test(pastedText)) {
        this.$emit('paste:bulk', {
          event: event,
          type: DelimiterType.newLine,
          model: this.model,
          text: pastedText,
          options: pastedText.split(newLineDelimiter),
          index: this.model.sort_order});
      } else if (!this.model.label_title && delimiter.test(pastedText)) {
        this.$emit('paste:bulk', {
          event: event,
          type: DelimiterType.commaSemicolon,
          model: this.model,
          text: pastedText,
          options: pastedText.split(delimiter),
          index: this.model.sort_order});
      } else {
        this.paste(pastedText, event.target, this.model, 'label_title');
      }
    }
  },
  watch: {
    isFocused(newVal) {
      if (newVal) {
        this.$refs.itemComponent.enableEditMode();
      }
    }
  }
};